import { motion } from "framer-motion";
import { waLink } from "../data";
import { useLang } from "../i18n";

export const WhatsAppFloat = () => {
  const { s } = useLang();
  return (
  <motion.a
    href={waLink("Namaste! I'm visiting the Shri Jamuna Dham website and have a question.")}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.5 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
    data-testid="whatsapp-live-chat-button"
    aria-label="Chat with us on WhatsApp"
  >
    <span className="pointer-events-none max-w-0 overflow-hidden whitespace-nowrap rounded-full bg-night px-0 py-2 text-sm font-medium text-cream opacity-0 shadow-xl transition-all duration-500 group-hover:max-w-[180px] group-hover:px-5 group-hover:opacity-100">
      {s.float.tooltip}
    </span>
    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/40">
      <span className="wa-ping absolute inset-0 rounded-full bg-[#25D366]" />
      <img
        src="/images/platforms/whatsapp.svg"
        alt=""
        className="relative h-7 w-7 brightness-0 invert"
      />
    </span>
  </motion.a>
  );
};
